var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQcInspector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1111 6.468L14.6111 2.343C14.5004 2.2821 14.3761 2.25017 14.2497 2.25017C14.1233 2.25017 13.999 2.2821 13.8883 2.343L6.38827 6.468C6.27068 6.53274 6.17262 6.62786 6.10432 6.74342C6.03603 6.85899 6 6.99076 6 7.125C6 7.25924 6.03603 7.39101 6.10432 7.50658C6.17262 7.62214 6.27068 7.71726 6.38827 7.782L13.4997 11.6935V19.7314L11.2225 18.4795L10.4997 19.7934L13.8883 21.657C13.999 21.718 14.1233 21.75 14.2497 21.75C14.3761 21.75 14.5004 21.718 14.6111 21.657L22.1111 17.532C22.2288 17.4673 22.3269 17.3722 22.3952 17.2566C22.4636 17.1411 22.4997 17.0093 22.4997 16.875V7.125C22.4997 6.99073 22.4636 6.85894 22.3952 6.74337C22.3269 6.6278 22.2288 6.5327 22.1111 6.468ZM14.2497 3.8562L16.9996 5.36858L20.1933 7.125L14.2497 10.3938L11.2779 8.7594L8.30609 7.125L14.2497 3.8562ZM20.9997 16.4315L14.9997 19.7315V11.6935L20.9997 8.39348V16.4315Z",
    fill: "#3A4861"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12V7H7.5V12H6Z",
    fill: "#3A4861"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9L18 5",
    stroke: "#3A4861",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17.9425L2.0575 16L1 17.0575L4 20.0575L10 14.0575L8.9425 13L4 17.9425Z",
    fill: "#3A4861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQcInspector);
export default __webpack_public_path__ + "static/media/QCInspector.0b9d7e0ee52677e4c9541e6287221cc8.svg";
export { ForwardRef as ReactComponent };